import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../../components/header/draft/Icon';
import { ModalContext } from '../../contexts/ModalContext';
import './payment-failed-modal.css';

type FailedPaymentModalProps = {
  content?: string;
  reason?: 'default' | 'invalidCard';
};

export default function FailedPaymentModal({ content, reason = 'default' }: FailedPaymentModalProps) {
  const { t } = useTranslation();
  const { handleModal } = useContext(ModalContext);

  const message =
    content ??
    (reason === 'invalidCard'
      ? t('paymentFailedModal.invalidCard')
      : t('paymentFailedModal.defaultMessage'));

  return (
    <div
      className="payment-failed-modal"
      role="alertdialog"
      aria-labelledby="payment-failed-modal-title"
      aria-describedby="payment-failed-modal-message"
    >
      <div className="payment-failed-modal__icon-wrap">
        <Icon name="credit_card_off" className="payment-failed-modal__icon" filled />
      </div>

      <h2 id="payment-failed-modal-title" className="payment-failed-modal__title">
        {t('paymentFailedModal.title')}
      </h2>

      <p id="payment-failed-modal-message" className="payment-failed-modal__message">
        {message}
      </p>

      <button type="button" className="payment-failed-modal__btn" onClick={() => handleModal()}>
        {t('paymentFailedModal.confirm')}
      </button>
    </div>
  );
}
